import React, { useCallback, useRef, useState } from 'react';

import CrmIframe from '../CrmIframe/CrmIframe';

import styles from './Slide.scss';

interface Props {
  content: string;
  withOverlay?: boolean;
}

enum TagName {
  BUTTON,
  A
}
const Slide: React.FC<Props> = ({ withOverlay, content }) => {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const [pointing, setPointing] = useState(false);

  const handleInteration = useCallback(
    (e: React.SyntheticEvent<HTMLElement>) => {
      e.preventDefault();
      const iframe = iframeRef.current;
      if (iframe) {
        const { contentDocument } = iframe;
        if (contentDocument) {
          const nativeEvent = e.nativeEvent as MouseEvent;
          const { offsetX, offsetY } = nativeEvent;
          const elem = contentDocument.elementFromPoint(offsetX, offsetY);

          if (elem) {
            switch (e.type) {
              case 'click': {
                const newEvent = contentDocument.createEvent('MouseEvents');
                newEvent.initEvent('click', true, true);
                elem.dispatchEvent(newEvent);
                break;
              }
              case 'mousemove':
                if (elem.tagName in TagName) {
                  if (!pointing) {
                    setPointing(true);
                  }
                } else {
                  setPointing(false);
                }
                break;
            }
          }
        }
      }
    },
    [pointing]
  );

  return (
    <div className="slide">
      {withOverlay ? (
        <div
          style={{ cursor: pointing ? 'pointer' : 'auto' }}
          className={styles.overlay}
          onClick={handleInteration}
          onMouseMove={handleInteration}
        />
      ) : null}
      <CrmIframe crmIframeRef={iframeRef} html={content} data-testid="crm-slide" />
    </div>
  );
};

export default Slide;
